export const AbsenceRequest = {
    path: '/absence_requests',
    name: 'absence_requests',
    component: () => import('@/views/Absence/AbsenceRequest/AbsenceRequestPage.vue'),
    children: [
        {
            path: '/absence_requests/add',
            name: 'absence_requests.add',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/absence_requests/edit/:id',
            name: 'absence_requests.edit',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/absence_requests/delete/:id',
            name: 'absence_requests.delete',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/absence_requests/view/:id',
            name: 'absence_requests.view',
            component: () => import('@/views/Absence/AbsenceRequest/Form/AbsenceRequestForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/absence_requests/set_decision/:id/:module',
            name: 'absence_requests.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/absence_requests/timelines/:id/:module',
            name: 'absence_requests.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
        {
            path: '/absence_requests/documents/:id',
            name: 'absence_requests.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "ABSENCE_REQUEST"}
        },
    ]
}

export const AbsenceRequestCalendar = {
    path: '/absence_requests_calendar',
    name: 'absence_requests_calendar',
    component: () => import('@/views/Absence/AbsenceRequest/AbsenceRequestCalendar.vue'),
    children: [
        {
            path: '/absence_requests_calendar/set_decision/:id/:module',
            name: 'absence_requests_calendar.set_decision',
            component: () => import('@/views/Request/Components/SetDecision.vue'),
        },
        {
            path: '/absence_requests_calendar/timelines/:id/:module',
            name: 'absence_requests_calendar.timelines',
            component: () => import('@/views/Request/Components/ValidationTimelines.vue'),
        },
    ],
}

export const AbsenceRequestBalance = {
    path: '/absence_requests_balance',
    name: 'absence_requests_balance',
    component: () => import('@/views/WorkerBalance/WorkerBalancePage.vue'),
    children: [
        {
            path: '/absence_requests_balance/manual/produce/:id',
            name: 'absence_requests_balance.manual.produce',
            component: () => import('@/views/WorkerBalance/Form/ManualForm.vue'),
            props: {produce: true}
        },
        {
            path: '/absence_requests_balance/manual/consume/:id',
            name: 'absence_requests_balance.manual.consume',
            component: () => import('@/views/WorkerBalance/Form/ManualForm.vue'),
            props: {consume: true}
        },
        {
            path: '/absence_requests_balance/request/view/:id',
            name: 'absence_requests_balance.request.view',
            component: () => import('@/views/Absence/Vacation/Form/VacationForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/absence_requests_balance/pay_slip/view/:id',
            name: 'absence_requests_balance.pay_slip.view',
            component: () => import('@/views/PaySlip/Form/PaySlipView.vue'),
        },
        {
            path: '/absence_requests_balance/init',
            name: 'absence_requests_balance.init',
            component: () => import('@/views/WorkerBalance/Form/InitWorkerBalanceForm'),
        },
    ]
}